module.exports = __webpack_public_path__ + "img/ic-level-intermediate.7a4650c7.svg";